import { AbTestExperiments } from '@shopee-user/business-customization-types';
import type { AbTestExperimentEvaluatorMap } from '@shopee-user/business-customization-types';

export const AB_TEST_EVALUATOR_FUNCTION: AbTestExperimentEvaluatorMap = {
  [AbTestExperiments.HideBiometricsSetupLater]: () => false,
};
